@if (reviews$ | async; as reviewsAndStats) {
  @if (reviewsAndStats.reviews) {
    <div
      class="row gy-2"
      trackImpression="contentblock-impression"
      [trackImpressionInfo]="rendering"
      [trackImpressionContext]="context"
    >
      <div class="col-lg-4 col-12">
        @if (rendering) {
          <wl-review-score
            [rendering]="rendering"
            [stats]="reviewsAndStats"
            [showCard]="false"
            type="entry"
          ></wl-review-score>
        }
      </div>
      <div class="col-lg-4 col-12">
        @if (reviewsAndStats.reviews[0]; as review) {
          <wl-review class="d-block h-100" [review]="review" />
        }
      </div>
      <div class="col-lg-4 col-12">
        @if (reviewsAndStats.reviews[1]; as review) {
          <wl-review class="d-block h-100" [review]="review" />
        }
      </div>
    </div>
  }
}
